/**
 * True when the document arrived as prerendered markup rather than the SPA
 * fallback shell. Evaluated at module load, before React mounts.
 *
 * Entrance animations must not run on the first paint of a prerendered page:
 * the snapshot captures the settled state, so animating from a different
 * initial state would mismatch during hydration (and re-hide content the user
 * can already see).
 */
export const wasPrerendered =
  typeof document !== 'undefined' &&
  !!document.getElementById('root')?.firstElementChild;
